import React from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
} from '@mui/icons-material';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onFilterClick?: () => void;
  showFilter?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = "Search all trips and itineraries",
  value,
  onChange,
  onFilterClick,
  showFilter = true,
}) => {
  return (
    <Box sx={{ mb: 2,justifyContent: 'center', alignItems: 'center', display: 'flex' ,flexDirection: 'row'}}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '100px',
            backgroundColor: '#FBEEE8',
            // '& fieldset': {
            //   borderColor: 'grey.200',
            // },
            // '&:hover fieldset': {
            //   borderColor: 'grey.300',
            // },
            // '&.Mui-focused fieldset': {
            //   borderColor: 'primary.main',
            // },
          },
        }}
        InputProps={{
          // startAdornment: (
          //   <InputAdornment position="start">
          //     <SearchIcon color="action" />
          //   </InputAdornment>
          // ),
          endAdornment: showFilter ? (
            <InputAdornment position="end">
              <IconButton onClick={onFilterClick} size="small">
              <SearchIcon color="action" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: '10px' }}>
        <FilterListIcon />
      </Box>
    </Box>
  );
};

export default SearchBar; 